"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("@mui/material/styles"),e=o.styled("div",{shouldForwardProp:r=>r!=="offset"})`
  position: sticky;
  bottom: 0;
  left: ${({offset:r})=>`${r??0}px`};
  width: ${({offset:r})=>`calc(100% - ${r??0}px)`};
  height: 14px;
  background: transparent;
  z-index: 3;
  cursor: pointer;
`,l=o.styled("div",{shouldForwardProp:r=>r!=="isDragging"&&r!=="width"})(({theme:r,isDragging:t})=>({position:"absolute",top:"calc(50% - 4px)",height:"8px",background:t?r.palette.grey[500]:r.palette.grey[400],borderRadius:"100px",zIndex:1,"&:hover":{background:r.palette.grey[500]}}));exports.ScrollbarControl=l;exports.ScrollbarWrapper=e;
